import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: "Mulish",
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          "&:first-child": {
            paddingLeft: 0,
          },
          "&:last-child": {
            paddingRight: 0,
          },
        },
      },
    },
  },
});

export default theme;
